import React, { useState } from 'react';
import {
  ICustomsInfo,
  ICustomsSignerInfo,
} from './customs_info_utils';
import { MultiOrderCustomsInfo } from './multi_order_customs_info';
import {
  Order,
  core_apimessages_Country as Country,
  core_apimessages_Address,
  MultiOrderCustomsInfoQueryQuery,
} from '@reverbdotcom/commons/src/gql/graphql';

interface IProps {
  selectedOrders: Order[];
  fromAddress: core_apimessages_Address;
  countries: Country[];
  exchangeRates: MultiOrderCustomsInfoQueryQuery['exchangeRates']['rates'];
  customsInfo: ICustomsInfo[];
}

const defaultSignerInfo: ICustomsSignerInfo = {
  customsSigner: '',
  certifiesAccuracy: false,
};

const MultiOrderCustomsInfoReturnsWrapper: React.FC<IProps> = ({
  selectedOrders,
  fromAddress,
  countries,
  exchangeRates,
  customsInfo: initialCustomsInfo,
}) => {
  const [customsInfo, setCustomsInfo] = useState<ICustomsInfo[]>(initialCustomsInfo);

  const [customsSignerInfo, setCustomsSignerInfo] = useState<ICustomsSignerInfo>(defaultSignerInfo);

  const updateCustomsInfo = (newCustomsInfo: ICustomsInfo[]) => {
    setCustomsInfo([...newCustomsInfo]);
  };

  const updateCustomsSignerInfo = (newSignerInfo: ICustomsSignerInfo) => {
    setCustomsSignerInfo({ ...newSignerInfo });
  };

  return (
    <MultiOrderCustomsInfo
      selectedOrders={selectedOrders}
      customsInfo={customsInfo}
      customsSignerInfo={customsSignerInfo}
      updateCustomsInfo={updateCustomsInfo}
      updateCustomsSignerInfo={updateCustomsSignerInfo}
      fromAddress={fromAddress}
      countries={countries}
      exchangeRates={exchangeRates}
    />
  );
};

export default MultiOrderCustomsInfoReturnsWrapper;
